
import api from '../api';

/**
 * Place an order using the provided details.
 *
 * @param {string} tableCode - The code for the table.
 * @param {Date} startTime - The starting time for the order.
 * @param {Date} endTime - The ending time for the order.
 * @param {Array<Object>} coupons - The list of coupons to be added.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const placeOrderV2 = async (tableCode, startTime, priceIndex, coupons, invoice) => {

  const requestData = {
    table_code: tableCode,
    start_time: startTime,
    price_index: priceIndex,
    coupon_ids:coupons,
    ...(invoice ? { invoice } : {}),
  };

  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/order/placeV2", requestData);
    return response.data;
  } catch (error) {
    console.error('Error while placing order:', error);
    throw error;
  }
}

export default placeOrderV2;
